/**
 * Check if a user email is from an allowed domain for special features
 * @param {string} email - User email to check
 * @returns {boolean} - True if email is from allowed domain
 */
export const isAllowedDomain = (email) => {
  if (!email) return false;
  
  const allowedDomains = ['@hectorai.live', '@neondigital.media'];
  return allowedDomains.some(domain => String(email).indexOf(domain) > -1);
};

/**
 * Get user from localStorage and check if they have an allowed domain
 * @returns {boolean} - True if user exists and has allowed domain
 */
export const isUserFromAllowedDomain = () => {
  try {
    const User = JSON.parse(localStorage.getItem('User'));
    return User?.email ? isAllowedDomain(User.email) : false;
  } catch (error) {
    console.error('Error checking user domain:', error);
    return false;
  }
}; 